<div class="downloadApp alone">
    <p class="title">
      {{"home.Download our app"|translate}}
    </p>
    <a href="https://play.google.com/store/apps/details?id=sa.com.expertapps.walla"><img src="/assets/images/google_play.png" alt="image"></a>
    <a href="https://apps.apple.com/us/app/offerx-1/id6503241299?uo=4"><img src="/assets/images/appStore.png" alt="image"></a>
  </div>